module.exports = __webpack_public_path__ + "quilt1-level4.2a0ba3e8.png";